import React from "react"
import ReactDOM from "react-dom"
import { Viewer, Worker, LocalizationMap, SpecialZoomLevel } from "@react-pdf-viewer/core"
import "@react-pdf-viewer/core/lib/styles/index.css"

import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout"
import "@react-pdf-viewer/default-layout/lib/styles/index.css"

import { SearchIcon } from "@react-pdf-viewer/search"
import SearchSidebar from "./SearchSidebar"
import RenderToolbar from "./RenderToolbar"

import de_DE from "@react-pdf-viewer/locales/lib/de_DE.json"
import ZoomPlugin from "./ZoomPlugin"

interface DefaultLayoutExampleProps {
    fileUrl: string
}

const urlParams = new URLSearchParams(window.location.search)
let fileUrl = urlParams.get("src")

// replace www.familienunternehmen.de with archiv.familienunternehmen.de
fileUrl = fileUrl.replace("www.familienunternehmen.de", "archiv.familienunternehmen.de")
console.log("fileUrl: ", fileUrl)

// const fileUrl = "https://www.familienunternehmen.de//media/public/pdf/publikationen-studien/studien/Die-Energiekrise-im-Standortvergleich_Studie_Stiftung-Familienunternehmen.pdf"
const searchStr = urlParams.get("search")

document.title = fileUrl.split("/").reverse()[0]

interface SearchSidebarWithDefaultLayoutExampleProps {
    fileUrl: string
}

const App: React.FC<SearchSidebarWithDefaultLayoutExampleProps> = ({ fileUrl }) => {
    const customZoomPluginInstance = ZoomPlugin()
    const { zoomTo } = customZoomPluginInstance

    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        renderToolbar: RenderToolbar,
        sidebarTabs: (defaultTabs) =>
            [
                {
                    content: (
                        <SearchSidebar
                            searchPluginInstance={
                                defaultLayoutPluginInstance.toolbarPluginInstance.searchPluginInstance
                            }
                            initialSearch={searchStr}
                        />
                    ),
                    icon: <SearchIcon />,
                    title: "Suche",
                },
            ].concat(defaultTabs),
        // toolbarPlugin: {
        //     fullScreenPlugin: {
        //         // Zoom to fit the screen after entering and exiting the full screen mode
        //         onEnterFullScreen: (zoom) => {
        //             zoom(SpecialZoomLevel.PageFit)
        //         },
        //         onExitFullScreen: (zoom) => {
        //             zoom(SpecialZoomLevel.PageFit)
        //         },
        //     },
        // },
    })

    if (searchStr) {
        const { activateTab } = defaultLayoutPluginInstance
        activateTab(0)
    }

    return (
        <Viewer
            fileUrl={fileUrl}
            plugins={[defaultLayoutPluginInstance, customZoomPluginInstance]}
            localization={de_DE as unknown as LocalizationMap}
            onDocumentLoad={() => {
                zoomTo(SpecialZoomLevel.PageFit)
            }}
        />
    )
}

ReactDOM.render(
    <Worker workerUrl="/assets/js/pdf.worker.min.js">
        <App fileUrl={fileUrl} />
    </Worker>,
    document.querySelector("#root")
)
